module.exports = __webpack_public_path__ + "static/img/otherright1.4a4846a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/otherright1.png
// module id = F46p
// module chunks = 1